module.exports = __webpack_public_path__ + "img/logo2.fac364ef.png";